import request from '@/utils/request'

export default {
  getCourseList(page, size, keyword, categoryId) {
    return request.get('/course/list', {
      params: { page, size, keyword, categoryId }
    })
  },

  getCourseById(id) {
    return request.get(`/course/${id}`)
  },

  addCourse(courseData) {
    return request.post('/course/add', courseData)
  },

  updateCourse(courseData) {
    return request.put('/course/update', courseData)
  },

  deleteCourse(id) {
    return request.delete(`/course/${id}`)
  },

  uploadVideo(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/course/upload/video', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  uploadCover(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/course/upload/cover', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}
